/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockCancel = createReactComponent("outline", "clock-cancel", "IconClockCancel", [["path", { "d": "M20.997 12.25a9 9 0 1 0 -8.718 8.745", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-3" }]]);

export { IconClockCancel as default };
//# sourceMappingURL=IconClockCancel.mjs.map
